module.exports = __webpack_public_path__ + "static/media/3.1ef51ba2.jpg";